import { ServiceAppService } from './../../../../security/service-app.service';
import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AtivacaoMenuListaService } from './ativacao-menu-lista.service';
import { Nivel } from './Nivel';

@Component({
  selector: 'app-ativacao-menu-lista',
  templateUrl: './ativacao-menu-lista.component.html',
  styleUrls: ['./ativacao-menu-lista.component.scss']
})

export class AtivacaoMenuListaComponent implements OnInit {

  cols: any[];
  dados: any[];
  _selectedColumns: any[];
  loading: boolean;
  nivel: Nivel[];

  constructor(
    private messageService: MessageService,
    private service: ServiceAppService,
    private ativacaoService: AtivacaoMenuListaService) { 

      this.nivel = [
        {nivel: 'Admin', code: 1},
        {nivel: 'Fabrica', code: 2},
        {nivel: 'Dealer/Fabrica', code: 3}
      ]
    }

  ngOnInit(): void {
    this.retornaDados();
    
    this.cols = [
      { field: 'menu', header: 'Menu', width: 'auto' },
      { field: 'subMenu', header: 'SubMenu', width: 'auto' },
      { field: 'visivel', header: 'Visibilidade', width: '120px' }
    ];

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getDados('/ativacao_menu').subscribe(
      res => {
        this.dados = res.dados;
        this.loading = false;
      },
      _err => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Erro ao carregar dados', detail: 'Não foi possível carregar os dados' });
      }
    );
  }

  alteraVisibilidade(rowData) {
    rowData.visivel = !rowData.visivel;
    this.ativacaoService.ativacaoMenuAlteraVisibilidade(`ativacao_menu/${rowData.ordem}/${rowData.visivel}`).subscribe(
      res => {
        this.messageService.add({ severity: 'success', summary: 'Visibilidade alterada com sucesso', detail: 'Via MessageService' });
        this.retornaDados();
      },
      err => {
        rowData.visivel = !rowData.visivel;
        this.messageService.add({ severity: 'error', summary: 'Erro ao alterar visibilidade', detail: 'Via MessageService' });
      }
    );
  }

  reloading() {
    window.location.reload();
  }

  alterarNivel(rowData) {
    this.ativacaoService
    .ativacaoMenuAlteraVisibilidade(`ativacao_menu/alterarNivel?ordem=${rowData.ordem}&nivel=${rowData.nivel}`)
    .toPromise()
  }
}
